import { ChakraProvider, localStorageManager } from "@chakra-ui/react";
import { AccountsProvider, ActionsProvider, EventStoreProvider } from "applesauce-react/providers";
import React, { useMemo } from "react";

import useAppSettings from "../../hooks/use-user-app-settings";
import accounts from "../../services/accounts";
import actions from "../../services/actions";
import { eventStore } from "../../services/event-store";
import buildTheme from "../../theme";
import BreakpointProvider from "./breakpoint-provider";
import { UserEmojiProvider } from "./emoji-provider";
import PublishProvider from "./publish-provider";

function ThemeProviders({ children }: { children: React.ReactNode }) {
  const { theme: themeName, primaryColor } = useAppSettings();
  const theme = useMemo(() => buildTheme(themeName, primaryColor), [themeName, primaryColor]);

  return (
    <ChakraProvider theme={theme} colorModeManager={localStorageManager}>
      <BreakpointProvider>{children}</BreakpointProvider>
    </ChakraProvider>
  );
}

// Top level providers, should be render as close to the root as possible
export const GlobalProviders = ({ children }: { children: React.ReactNode }) => {
  return (
    <EventStoreProvider eventStore={eventStore}>
      <AccountsProvider manager={accounts}>
        <ActionsProvider runner={actions}>
          <ThemeProviders>
            <PublishProvider>
              <UserEmojiProvider>{children}</UserEmojiProvider>
            </PublishProvider>
          </ThemeProviders>
        </ActionsProvider>
      </AccountsProvider>
    </EventStoreProvider>
  );
};
